angular.module('cimerFrontEndApp').service('DocumentService', ['$q', '$http', 'ApiUrl',
    function ($q, $http, ApiUrl) {
        'use strict';
        var _apiUrl = ApiUrl.url('/Document/');

        return {
            getDocumentTypes: function () {
                return $http.get(_apiUrl + 'GetDocumentTypes');
            },

            getResearchRoles: function () {
                return $http.get(_apiUrl + 'GetResearchRoles');
            },

            getAllDocumentTags: function () {
                return $http.get(_apiUrl + 'GetAllDocumentTags');
            },

            getAllDocumentLabels: function () {
                return $http.get(_apiUrl + 'GetAllDocumentLabels');
            },

            getAllDocuments: function () {
                return $http.get(_apiUrl + 'GetAllDocuments/' );
            },

            setDocumentActiveState: function (activeState) {
                return $http.get(_apiUrl + 'SetDocumentActiveState');
            },

            getPDFDocumentForDownload: function (documentID) {
                return $http.get(_apiUrl + 'GetDocument/' + documentID, { responseType: 'arraybuffer' });
            },

            editDocument: function (documentID) {
                var config = {
                    params: {
                        documentID: documentID
                    }
                };

                return $http.get(_apiUrl + 'EditDocument', config);
            },

            uploadDocument: function (data) {
                var formData = new FormData();

                formData.append('DocumentType', angular.toJson(data.DocumentType));
                formData.append('DocumentLabel', angular.toJson(data.DocumentLabel));
                formData.append('Active', data.Active);
                formData.append('Context', data.Context);            
                formData.append('Title', data.Title);
                formData.append('SelectedTags', angular.toJson(data.SelectedTags));
                formData.append('PrimaryTag', angular.toJson(data.PrimaryTag));
                
                if (!angular.equals(data.Contents, [])) {                   
                    formData.append('Contents', data.Contents, data.Contents.name);
                }

                if (data.DocumentID) {
                    formData.append('DocumentID', data.DocumentID);
                }

                var config = {
                    headers: {
                        'Content-Type': undefined
                        //So doing this will force the browser to fill in the multipart header including the boundary, which is key for identifying the request as a multipart one
                    }
                };

                return $http.post(_apiUrl + "UploadDocument", formData, config);
            },

            getCategories: function () {
                return $http.get(_apiUrl + 'GetCategories');
            },

            getTagsByCategory: function (categoryID) {
                return $http.get(_apiUrl + 'GetTagsByCategory/' + categoryID);
            },

            getDocumentsByResearchRole: function (roleID) {
                return $http.get(_apiUrl + 'GetDocumentsByResearchRole/' + roleID);
            },

            getCompleteDocumentsByResearchRole: function (roleID) {
                return $http.get(_apiUrl + 'GetCompleteDocumentsByResearchRole/' + roleID);
            }

        };
    }]);